import React from 'react';
import { Mutation } from 'react-apollo';
import Propagator from '../../Propagator';
import gql from 'graphql-tag';

const SUBMIT = gql`
	mutation($gameID: ID!) {
		submit(gameID: $gameID) @client {
			id
			data
		}
	}
`;

const START_LOADING = gql`
	mutation {
		startLoading @client
	}
`;
const STOP_LOADING = gql`
	mutation {
		stopLoading @client
	}
`;

export default ({ children }) => (
	<Mutation mutation={SUBMIT}>
		{submit => {
			return (
				<Mutation mutation={START_LOADING}>
					{startLoading => (
						<Mutation mutation={STOP_LOADING}>
							{stopLoading =>
								Propagator(children, { submit, startLoading, stopLoading })
							}
						</Mutation>
					)}
				</Mutation>
			);
		}}
	</Mutation>
);
